import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const ExternalLinkGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#3B4046', props);
  return (
    <g fill={'none'} {...(props.group ?? {})}>
      <path
        d="M12.5 8.66667V12.6667C12.5 13.0203 12.3595 13.3594 12.1095 13.6095C11.8594 13.8595 11.5203 14 11.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V5.33333C2.5 4.97971 2.64048 4.64057 2.89052 4.39052C3.14057 4.14048 3.47971 4 3.83333 4H7.83333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={strokeColor}
      />
      <path
        d="M10.5 2H14.5V6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={strokeColor}
      />
      <path
        d="M7.16602 9.33333L14.4993 2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={strokeColor}
      />
    </g>
  );
};

export const ExternalLinkSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      viewBox={`0 0 16 16`}
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <ExternalLinkGroup {...props} />
    </svg>
  );
};
